export default class TsdiClient {
    clientNumber: number;
    dayRate?: number;
    billBy?: string;
    clientName: string;
    formatType?: string;
    backupOfficeRate?: number;
    mileageRate?: number;
    defaultDayRate?: number;
    address?: string;
    city?: string;
    state?: string;
    zip?: number;
    phone?: string;
    invoiceType?: number;
}


// WEBPACK FOOTER //
// ./src/models/AP/Client.ts